import { render, staticRenderFns } from "./editCtp.vue?vue&type=template&id=652f0302&scoped=true&"
import script from "./editCtp.vue?vue&type=script&lang=js&"
export * from "./editCtp.vue?vue&type=script&lang=js&"
import style0 from "./editCtp.vue?vue&type=style&index=0&id=652f0302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f0302",
  null
  
)

export default component.exports